import { render, staticRenderFns } from "./RoleUpdate.vue?vue&type=template&id=2d2c0f4e&scoped=true&"
import script from "./RoleUpdate.vue?vue&type=script&lang=js&"
export * from "./RoleUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2c0f4e",
  null
  
)

export default component.exports